import { Table } from "@/features/Table";
import { type Permission, permissions_columns } from "./columns";
import { type FilterPermissionsSchema, FilterPermissions } from "./filter";

const client = "legacy-quantilia";
const table_name = "permissions";

export const PermissionsTable = () => {
  return (
    <Table<Permission, FilterPermissionsSchema>
      label="Permissions"
      client={client}
      table_name={table_name}
      columns={permissions_columns}
      filter={<FilterPermissions />}
      disable_translations_request={true}
    />
  );
};
